export default (state= '', action) => {
    switch (action.type){
        case 'COMPARE_MARKET_SELECTED':
            return action.payload;
        default:
            return state;
    }
};